// extracted by mini-css-extract-plugin
module.exports = {"link":"demo_cell-module--link--2VHoC","demoIcon":"demo_cell-module--demoIcon--3rvl4","title":"demo_cell-module--title--30Joe"};